// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2h8sq","modalFooterButton":"ModalNotes_modalFooterButton__1D4hy"};